export const UseUserUpdate = async (userObj: any) => {
	try {
		const response = await fetch(`${process.env.REACT_APP_API_URL}/api/auth/signup_user_web`, {
				method: 'POST',
				headers: {'Content-Type': 'application/json'},
				credentials: 'include',
				body: JSON.stringify({
					name: userObj.name,
					email: userObj.email,
					phoneNr: userObj.phone,
					password: userObj.password
				})
		});
		let result = null;
		const status = response.status;
		if (status === 201) {
			result = await response.json();
		}
		return { result, status };
	} catch (e) {
		console.log(e);
	}
}

export const UseGetUserInfo = async (userId: string) => {
	try {
		const response = await fetch(`${process.env.REACT_APP_API_URL}/api/user/get_user_by_id/${userId}`, {
			method: 'GET',
			headers: {'Content-Type': 'application/json'},
			credentials: 'include',
		});
		let result = null;
		const status = response.status;
		if (status === 200) {
			result = await response.json();
		}
		return { result, status };
	} catch (e) {
		console.log(e);
	}
}

export const SetUserCoords = async (userId: string, latitude: number, longitude: number) => {
	try {
		//console.log(`SetUserCoords - userId: ${userId}, latitude: ${latitude}, longitude: ${longitude}`)
		const response = await fetch(`${process.env.REACT_APP_API_URL}/api/user/set_user_coordinates`, {
			method: 'POST',
			headers: {'Content-Type': 'application/json'},
			credentials: 'include',
			body: JSON.stringify({
				userId,
				latitude,
				longitude,
			})
		});
		
		const data = await response.json();
		if (response && response.status === 201 && data) {
			//console.log("SetUserCoords data: ", data);
			return data;
		} else {
			//data && data.message && toast.error(data.message);
			return null;
		}
	} catch (e) {
		console.log(e);
	}
}

/*export const UseLogin = async (userObj: any) => {
	try {
		if (userObj.email && userObj.password) {
			console.log("userObj: ", userObj.email, userObj.password);
			const response = await fetch(`${process.env.REACT_APP_API_URL}/api/auth/signin_user_web`, {
				method: 'POST',
				headers: {'Content-Type': 'application/json'},
				body: JSON.stringify({
					email: userObj.email.toLowerCase(),
					password: userObj.password
				}),
				credentials: 'include'
			});
			let result = null;
			const status = response.status;
			if (status === 200) {
				result = await response.json();
			}
			return { result, status };
		}
	} catch (e) {
		console.log(e);
	}
}*/

/*export const UseAuth = async (token: any) => {
	try {
		console.log("cookies token: ", token);
		const response = await fetch(`${process.env.REACT_APP_API_URL}/api/auth/auth_user_web`, {
			method: 'GET',
			headers: {
				'Content-Type': 'application/json',
			},
			
			// mode: 'no-cors'
		});

		let result = null;
		const status = response.status;
		if (status === 200) {
			result = await response.json();
		}
		return { result, status };
	} catch (e) {
		console.log(e);
	}
}*/